import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faExclamationCircle} from "@fortawesome/free-solid-svg-icons/faExclamationCircle";
import AppComponentCardHeader from "../../common/AppComponentCardHeader";
import "../../../../css/DictionaryForms.css";

const UserType = () => (
  <div id="layoutSidenav_content" className="settings-entity-page">
    <AppComponentCardHeader title="Typy użytkowników"/>
    <div className="container-fluid px-4 py-3">
      <div className="card shadow-sm bg-white rounded-2 p-3 mb-5">
        <div className="warn_info">
          <FontAwesomeIcon className="warning-icon div-visible" icon={faExclamationCircle}/>
          &nbsp;&nbsp;&nbsp;Moduł typów użytkowników nie jest jeszcze zaimplementowany.
        </div>
      </div>
    </div>
  </div>
);

export default UserType;
